
import React from 'react';
import { CheckThePwd } from '@/components/AccessBtn'

export default {
  rowSelection: false,
  fieldControl: false,
  searchFormConfig:false,
  columns: [
    {
      title: '酷家乐账号',
      dataIndex: 'kjlAccount',
      width: 180,
      fixed: 'left',
    },
    {
      title: '酷家乐账号名称',
      dataIndex: 'kjlName',
      width: 180,
    },
    {
      title: '关联生活家账号',
      dataIndex: 'appuid',
      width: 160,
    },
    {
      title: '使用分公司',
      dataIndex: 'companyName',
      width: 160,
    },
    {
      title: '使用人',
      dataIndex: 'user',
      width: 160,
      render: (text: any, record: any) => {
        if (record?.user) {
          return record?.user?.name;
        } else {
          return '';
        }
      },
    },
    {
      title: '密码',
      dataIndex: 'pwd',
      width: 200,
      render: (text: any, record: any) => {
        return (
          <>
            <CheckThePwd record={record} dataIndex={'pwd'} auth={'kjlCheckThePwdBtn'} />
            {/* {text} */}
          </>
        );
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 200,
    },
    {
      title: '最后修改人',
      dataIndex: 'modifiedByName',
      width: 120,
    },
    {
      title: '最后修改时间',
      dataIndex: 'lastUpdatedTime',
      width: 160,
      itemType:'dateTime'
    },
    {
      title: '操作',
      dataIndex: 'actionTool',
      width: 220,
      render: 'actionTool',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'kjlAccount',
      label: '酷家乐账号',
    },
    {
      name: 'kjlName',
      label: '酷家乐账号名称',
    },
    {
      name: 'companyCode',
      label: '公司',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companyList',
      addonOpts: [],
      showSearch: true,
      filterOption: (input: any, option: any) =>
        (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase()),
    },
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      auth: 'kuklerAccountAddBtn',
      events: ['onClick:onAdd'],
    },
    {
      label: '导入',
      auth: 'kuklerAccountImportBtn',
      render: 'importInfoExcel',
    },
    {
      label: '领用记录',
      auth: 'kuklerAccountUseRecordBtn',
      events: ['onClick:onUseRecord'],
    },
    {
      label: '下载模板',
      auth: 'kuklerAccountDownloadBtn',
      events: ['onClick:onDownload'],
    },
    {
      label: '更新酷家乐账户信息',
      auth: 'updateKjlInfoBtn',
      events: ['onClick:onUpdateKjlInfo'],
    },
  ],
};
